<!--
 * @Description: 字段列表
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div ref="scrollRef" :class="{ 'field-list-com': true, 'scrollbar-style-config': true, 'scroll-shadow-show': scrollShow }" v-if="(businessData1List?.length > 0 && props?.freeze) || businessData0List?.length > 0" @scroll="handleScroll" @mouseleave="mouseLeave">
    <!--  冻结列的数据显示 -->
    <template v-if="businessData1List?.length > 0 && props?.freeze">
      <draggable animation="500" :group="{ name: 'group', sort: true, pull: true, put: true }" :move="onMove1" @end="onEnd1" :list="data.businessData1Modules" class="field-list-draggable-content field-list-fixed" itemKey="id">
        <template #item="{ element, index }">
          <div v-if="element?.showField" class="field-list-com-content other-field-list-com-content" :key="index">
            <div class="field-list-left">
              <div class="sub-field-list-content">
                <div class="field-list-left">
                  <qfei-icon-more-two-outlined class="mover hand icon-drag-mover" size="14" />
                  <component :is="componentFun(element)" /><span class="field-name">{{ element.fieldName }}</span>
                </div>
              </div>
            </div>
            <div class="field-list-right">
              <jw-tooltip :content="$t('取消冻结')" position="lt">
                <jw-button type="text" size="small" class="icon-content icon-freeze-btn" @click="unFreeze(element, index)">
                  <qfei-icon-unlock-outlined />
                </jw-button>
              </jw-tooltip>
              <jw-tooltip v-if="showFieldList.length == 1 && !props.empty" position="lt" :content="$t('列表页展示至少需保留一个非子表单字段')">
                <jw-button type="text" size="small" class="icon-content delete-icon" disabled>
                  <qfei-icon-delete-outlined />
                </jw-button>
              </jw-tooltip>

              <jw-tooltip :content="$t('该查找关联(单选)字段为允许查找关联批量新增数据已配置字段，不可删除')" v-if="element.fieldKey == batchTableKey">
                <jw-button type="text" size="small" class="icon-content delete-icon" disabled>
                  <qfei-icon-delete-outlined />
                </jw-button>
              </jw-tooltip>

              <jw-tooltip v-else :content="$t('删除')">
                <jw-button type="text" size="small" class="icon-content delete-icon" @click="del(index, null, 1)">
                  <qfei-icon-delete-outlined />
                </jw-button>
              </jw-tooltip>
            </div>
          </div>
        </template>
      </draggable>
      <!-- 直接的间隔线 -->
      <div class="septal-line-content">
        <div class="septal-line"></div>
        <span class="septal-line-title">{{ $t('以上字段已冻结') }}</span>
        <div class="septal-line"></div>
      </div>
    </template>
    <!--  取消列的数据显示 -->
    <template v-if="businessData0List?.length > 0">
      <draggable animation="500" :group="{ name: 'group', sort: true, pull: true, put: true }" :move="onMove0" @end="onEnd0" :list="data.businessData0Modules" class="field-list-draggable-content field-list-no-fixed" itemKey="id">
        <template #item="{ element, index }">
          <div v-if="element?.showField" :class="['field-list-com-content', element?.fieldType == 27 ? 'sub-field-list-com-content' : 'other-field-list-com-content']" :key="index">
            <div :class="['field-list-left', element?.fieldType == 27 ? 'sub-field-list-left' : '']">
              <div :class="['sub-field-list-content', element?.fieldType == 27 ? 'sub-field-list-content-2' : '']">
                <div class="field-list-left">
                  <qfei-icon-more-two-outlined class="mover hand icon-drag-mover" size="14" />
                  <!-- 展开状态 -->
                  <icon-down size="14" v-if="element?.fieldType == 27 && element?.isExpandShow" class="sub-field-icon sub-field-retract" @click="retract(index)" />
                  <!-- 子表单收起状态 -->
                  <icon-right size="14" v-if="element?.fieldType == 27 && !element?.isExpandShow" class="sub-field-icon sub-field-expand" @click="expand(index)" />
                  <component :is="componentFun(element)" /><span class="field-name">{{ element.fieldName }}</span>
                </div>
                <!-- 子表单 -->
                <div v-if="element?.fieldType == 27" class="field-list-right">
                  <jw-tooltip content="">
                    <jw-button type="text" style="visibility: hidden" size="small" class="icon-content delete-icon">
                      <qfei-icon-delete-outlined />
                    </jw-button>
                  </jw-tooltip>
                  <jw-tooltip :content="$t('删除')">
                    <jw-button type="text" size="small" class="icon-content delete-icon" @click="del(index, null, 0)">
                      <qfei-icon-delete-outlined />
                    </jw-button>
                  </jw-tooltip>
                </div>
              </div>
              <!-- 子字段 -->
              <div v-if="element?.fieldType == 27 && element.modules?.length > 0 && element?.isExpandShow" class="sub-child-field-list-content">
                <draggable animation="500" :list="element.modules" :sort="true" class="sub-child-field-list-drag">
                  <template #item="{ element: subElement, index: subIndex }">
                    <div v-if="subElement?.showField" :class="['field-list-com-content', element?.fieldType == 27 ? 'sub-child-field-list-com-content' : '']" :key="subIndex">
                      <div class="field-list-left">
                        <qfei-icon-more-two-outlined class="hand icon-drag-mover" size="14" />
                        <div class="field-list-center">
                          <component :is="componentFun(subElement)" /><span class="field-name">{{ subElement.fieldName }}</span>
                        </div>
                      </div>
                      <div class="field-list-right">
                        <jw-tooltip content="">
                          <jw-button type="text" style="visibility: hidden" size="small" class="icon-content delete-icon">
                            <qfei-icon-delete-outlined />
                          </jw-button>
                        </jw-tooltip>
                        <jw-tooltip :content="$t('删除')">
                          <jw-button type="text" size="small" class="icon-content delete-icon" @click="del(index, subIndex, 0)">
                            <qfei-icon-delete-outlined />
                          </jw-button>
                        </jw-tooltip>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
            </div>
            <div class="field-list-right" v-if="element?.fieldType != 27">
              <jw-tooltip :content="$t('冻结')" position="lt" v-if="props.freeze">
                <jw-button type="text" size="small" class="icon-content icon-freeze-btn icon-freeze-tooltip" @click="freeze(element, index)">
                  <qfei-icon-lock-outlined />
                </jw-button>
              </jw-tooltip>
              <template v-if="allowDeleteMainField || !element?.mainField">
                <jw-tooltip v-if="showFieldList.length == 1 && !props.empty" position="lt" :content="$t('列表页展示至少需保留一个非子表单字段')">
                  <jw-button type="text" size="small" class="icon-content delete-icon" disabled>
                    <qfei-icon-delete-outlined />
                  </jw-button>
                </jw-tooltip>

                <jw-tooltip :content="$t('该查找关联(单选)字段为允许查找关联批量新增数据已配置字段，不可删除')" v-if="element.fieldKey == batchTableKey">
                  <jw-button type="text" size="small" class="icon-content delete-icon" disabled>
                    <qfei-icon-delete-outlined />
                  </jw-button>
                </jw-tooltip>

                <jw-tooltip v-else :content="$t('删除')">
                  <jw-button type="text" size="small" class="icon-content delete-icon" @click="del(index, null, 0)">
                    <qfei-icon-delete-outlined />
                  </jw-button>
                </jw-tooltip>
              </template>
            </div>
          </div>
        </template>
      </draggable>
    </template>
  </div>
  <!-- 可以为空的时候显示空状态 -->
  <template v-if="props?.freeze ? businessData1List?.length == 0 && businessData0List?.length == 0 : businessData0List?.length == 0">
    <jw-empty v-if="props?.empty"></jw-empty>
  </template>
</template>
<script setup>
import { computed, reactive, watchEffect, ref, onUnmounted } from 'vue';
import draggable from 'vuedraggable';
import { Message } from '@arco-design/web-vue';
// 最新的图表
import { QfeiIconUnlockOutlined, QfeiIconLockOutlined, QfeiIconDeleteOutlined, QfeiIconMoreTwoOutlined } from '@qfei-design/icons-vue';
const emits = defineEmits(['cb']);
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import useFields from '@/hooks/fields';
import setScrollBar from '@/hooks/scrollbar-config';
const { fieldIconMapping } = useFields();
const { scrollShow, handleScroll, mouseLeave } = setScrollBar();
const props = defineProps({
  list: {
    // 全部数据
    type: Object,
    default: () => {}
  },
  freeze: {
    //是否显示冻结(false:不显示，true：显示)
    type: Boolean,
    default: () => false
  },
  empty: {
    // 列表是否可以为空(false:不可以为空，true：可以为空)
    type: Boolean,
    default: false
  },
  allowDeleteMainField: {
    //是否允许删除主键字段
    type: Boolean,
    default: true
  },
  batchTableKey: {
    type: String,
    default: ''
  }
});
const data = reactive({
  fieldListData: {}, //110的所有数据
  businessData1Modules: [], //冻结字段信息
  businessData0Modules: [], //非冻结字段信息
  oprateList: [] //被操作的元素
});
const showFieldList = computed(() => {
  // 根据 props.freeze 决定使用的数据来源
  const source = props?.freeze ? [...data.businessData1Modules, ...data.businessData0Modules] : [...data.businessData0Modules];

  // 过滤掉子表类型且显示的字段
  return source?.filter((el) => el.fieldType !== 27 && el?.showField);
}); // 除了子表的显示的字段

const businessData1List = computed(() => data.businessData1Modules?.filter((el) => el?.showField)); //冻结列的数据
const businessData0List = computed(() => data.businessData0Modules?.filter((el) => el?.showField)); //非冻结的数据

const componentFun = (ele) => {
  //字段图表
  return fieldIconMapping.value[Number(ele.fieldType)];
};

// 展开
const expand = (index) => {
  data.businessData0Modules[index].isExpandShow = true;
};
// 收起
const retract = (index) => {
  data.businessData0Modules[index].isExpandShow = false;
};
const scrollRef = ref();
const timer = ref(null);
const initScroll = () => {
  //初始化滚动到顶部
  if (scrollRef.value?.scrollHeight) {
    scrollRef.value.scrollTop = 0;
  } else {
    timer.value = setTimeout(() => {
      initScroll();
    }, 100);
  }
};
onUnmounted(() => {
  if (timer.value !== null) window.clearTimeout(timer.value);
});
watchEffect(() => {
  data.fieldListData = props.list;
  const fieldListModules = props?.list?.modules;
  if (props?.freeze) data.businessData1Modules = fieldListModules?.filter((el) => el.businessData == 1);
  data.businessData0Modules = !props?.freeze ? fieldListModules : fieldListModules?.filter((el) => el.businessData != 1);

  initScroll();
});

const exposeFieldListData = () => {
  //抛出数据
  emits('cb', {
    ...data.fieldListData,
    modules: props?.freeze ? [...data.businessData1Modules, ...data.businessData0Modules] : [...data.businessData0Modules],
    oprateList: data.oprateList
  });
};
// 改变字段的businessData属性0，1
const updateBusinessData = (item, freeze) => {
  data.oprateList = [];

  const targetItem = { ...item, businessData: freeze ? '1' : '0' };
  if (freeze) {
    //冻结
    data.businessData1Modules.push(targetItem);
  } else {
    //非冻结
    data.businessData0Modules.unshift(targetItem);
  }
  exposeFieldListData();
};

// 取消冻结
const unFreeze = (item, index) => {
  data.businessData1Modules.splice(index, 1);
  updateBusinessData(item, false);
};
// 冻结
const freeze = (item, index) => {
  if (data.businessData1Modules?.length == 10) {
    //最多置顶10个字段
    Message.warning(t('最多冻结10个非子表单类型的字段!'));
    return false;
  }
  data.businessData0Modules.splice(index, 1);
  updateBusinessData(item, true);
};
// 封装添加操作项到 oprateList 的逻辑
const addToOprateList = (item) => {
  data.oprateList.push({ ...item, showField: false });
};
// 字段删除(type:0 非冻结，1 冻结)
const del = (index, subIndex, type) => {
  data.oprateList = [];
  if (subIndex !== null) {
    // 删除的子字段
    const subModules = data.businessData0Modules[index].modules;
    if (Array.isArray(subModules)) {
      subModules[subIndex].showField = false;
      addToOprateList(subModules[subIndex]);

      // 判断是否最后一个子字段被删除
      const allSubFieldsHidden = subModules.every((el) => !el.showField);
      if (allSubFieldsHidden) {
        // 最后一个子字段被删除，子表移除
        data.businessData0Modules[index].showField = false;
        addToOprateList({ ...data.businessData0Modules[index], modules: [] });
      }
    }
  } else {
    const item = type == 0 ? data.businessData0Modules[index] : data.businessData1Modules[index];
    addToOprateList({ ...item, modules: [] });

    if (item?.fieldType === 27) {
      // 子表单
      const subModules = item.modules;
      if (Array.isArray(subModules)) {
        subModules.forEach((element) => {
          element.showField = false;
          addToOprateList(element);
        });
      }
    }
    item.showField = false;
  }
  exposeFieldListData();
};
// 更新拖拽的字段businessData属性
const updateDraggableBusinessData = (item, freeze) => {
  if (freeze) {
    //冻结
    data.businessData1Modules.map((el) => {
      if (el.settingId == item.settingId) {
        el.businessData = '1';
      }
    });
  } else {
    //非冻结
    data.businessData0Modules.map((el) => {
      if (el.settingId == item.settingId) {
        el.businessData = '0';
      }
    });
  }
  exposeFieldListData();
};
const businessData1 = ref();
const businessData0 = ref();
//  拖拽(冻结的字段)
const onMove1 = (e) => {
  businessData1.value = e.draggedContext.element;
};
// 拖拽(取消冻结的字段)
const onMove0 = (e) => {
  const targetClass = e.to.getAttribute('class');
  if (targetClass == 'field-list-draggable-content field-list-fixed') {
    if (e.draggedContext?.element?.fieldType == 27) {
      //子表单不支持冻结
      return false;
    }
    if (data.businessData1Modules?.length == 10) {
      //最多置顶10个字段
      return false;
    }
  }

  businessData0.value = e.draggedContext.element;
};
// 拖拽结束(冻结的字段拖拽到非冻结)
const onEnd1 = (e) => {
  const targetClass = e.to.getAttribute('class');
  if (targetClass == 'field-list-draggable-content field-list-no-fixed' && businessData1.value?.settingId) {
    //取消冻结

    updateDraggableBusinessData(businessData1.value, false);
  } else {
    exposeFieldListData();
  }
};
// 拖拽结束(非冻结拖拽到冻结)
const onEnd0 = (e) => {
  const targetClass = e.to.getAttribute('class');
  if (data.businessData1Modules?.length == 10) {
    //最多置顶10个字段
    Message.warning(t('最多冻结10个非子表单类型的字段!'));
    return false;
  }
  if (targetClass == 'field-list-draggable-content field-list-fixed' && businessData0.value?.settingId) {
    //冻结

    updateDraggableBusinessData(businessData0.value, true);
  } else {
    exposeFieldListData();
  }
};
</script>

<style scoped lang="less">
@import './field-list.less';
</style>
